import { CommonUtility } from 'utility/common'
import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class ReportSettings {
    getReportSettings(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.reportSettings}?${params}`)
    }

    getReportSettingsList() {
        return BaseService.get(`${APIPath.reportSettingsList}`)
    }

    add(data) {
        return BaseService.post(`${APIPath.reportSettings}`, data)
    }

    update(data) {
        return BaseService.post(`${APIPath.reportSettings}`, data)
    }
}

const ReportSettingsService = new ReportSettings()
Object.freeze(ReportSettingsService)
export { ReportSettingsService }
